module.exports = __webpack_public_path__ + "static/image/promotion-command.svg?5e9278c35d185e832b9750b3ce0756df";